import { Component, OnInit } from '@angular/core';
import { FilterStreamService } from 'src/app/services/filterStream.service';
import { RoleStreamFilters } from '../../models/roleStreamFilters';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Component({
  selector: 'app-stream-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})

export class FilterStreamComponent implements OnInit {
  public roleStreamFilters: RoleStreamFilters;
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;

  constructor(
    private _filter: FilterStreamService,
    private timezoneService: TimeZoneService
  ) {
    this._filter.roleFiltersSubject.subscribe(
      (data:RoleStreamFilters) => {
        this.roleStreamFilters=data;
      }
    );
  }

  public updateRoleStreamFilters(event, property:string){
    this._filter.updateRoleStreamFilterValues(property, event.checked);
  }

  ngOnInit() {
    // Check the timeZone
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
  }
}